var map = {
	"./uclg/UCLG-CGLU+CLAIM.png": 39626,
	"./uclg/UCLG-CGLU-1tinta-12.png": 69729,
	"./uclg/UCLG-CGLU-blanco.jpg": 88607,
	"./uclg/UCLG-CGLU-blanco.png": 81711,
	"./uclg/Water_Mark.png": 88789,
	"./uclg/logo-uclg.png": 35577,
	"./uclg/presidency-meeting_0002_Vector-Smart-Object.png": 18175,
	"./uclg/water_mark_2.png": 71638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;